import React, { useState, useEffect } from "react";
import { verifyGST } from "../../shared/utils/gstInfoApi";
import CircularProgress from "@mui/material/CircularProgress"; // Material-UI spinner
import VerifiedTick from "../../shared/assets/icons/VerifiedTick";
import AddIcon from "@mui/icons-material/Add";
import { Edit, Delete } from "@mui/icons-material"; // Importing MUI Edit and Delete icons
import { Fab, FormLabel, IconButton, Modal } from "@mui/material";
import PrintMachineModal from "./printMachineModal";
import FabricationModal from "./FabricationModal";
import ProductsServicesModal from "./ProductServiceModal";
import { statecityData } from "../../shared/enums";
import Styles from "../../styles/vendorDashboard.module.css";
import MinMaxFileUploader from "../utils/minmaxFileUploader";
import CheckIcon from "@mui/icons-material/Check";
import GlobalDropdownField from "../../shared/utils/GlobalDropdownField";
import ProductPricingSection from "./ProductPriceSection.jsx";

// import Cross from "path/to/your/icons/Cross";
import { States, IndiaState } from "../../shared/enums";
import GlobalButton from "../../shared/utils/GlobalButton";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  ListItemText,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Cross } from "../../shared/assets/icons/index";
import CustomInput from "../../shared/utils/Input";
import axios from "axios";
import Swal from "sweetalert2";
import "./vendorOnboard.css";
import { validate } from "../utils/validation";
import FileUploader from "../utils/galleryUpload";
import dayjs from "dayjs";
import capitalizeWords from "../../helperFunctions/capitalizedWords.js";

const printingOptions = [
  { value: "Ecosolvent Printing", label: "Ecosolvent Printing" },
  { value: "UV Printing", label: "UV Printing" },
  { value: "Digital Printing", label: "Digital Printing" },
  { value: "Solvent Printing", label: "Solvent Printing" },
  { value: "Plotter Cutting Printing", label: "Plotter Cutting Printing" },
  { value: "Latex Printing", label: "Latex Printing" },
];

const printingSubOptions = [
  { value: "Roll 2 Roll", label: "Roll 2 Roll" },
  { value: "FlatBed", label: "Flat Bed" },
  { value: "Hybrid", label: "Hybrid" },
];
const width = {
  "Ecosolvent Printing": [
    { value: "5", label: "5'" },
    { value: "10", label: "10'" },
  ],
  "UV Printing": [
    { value: "2", label: "2'" },
    { value: "4", label: "4'" },
    { value: "6", label: "6'" },
    { value: "8", label: "8'" },
    { value: "10", label: "10'" },
    { value: "12", label: "12'" },
    { value: "14", label: "14'" },
  ],
  "Digital Printing": [
    { value: "4", label: "4'" },
    { value: "5", label: "5'" },
    { value: "6", label: "6'" },
  ],
  "Solvent Printing": [
    { value: "8", label: "8'" },
    { value: "10", label: "10'" },
    { value: "12", label: "12'" },
    { value: "14", label: "14'" },
  ],
  "Plotter Cutting Printing": [
    { value: "2", label: "2'" },
    { value: "3", label: "3'" },
    { value: "4", label: "4'" },
    { value: "5", label: "5'" },
  ],
  "Latex Printing": [
    { value: "5", label: "5'" },
    { value: "7", label: "7'" },
    { value: "8", label: "8'" },
    { value: "10", label: "10'" },
  ],
};

const brandNames = [
  {
    value: "Latex Printing",
    brandNames: ["HP", "Other Brands"],
  },
  {
    value: "Ecosolvent Printing",
    brandNames: [
      "Roland",
      "Mimaki",
      "Xuly",
      "Konica",
      "ColorJet",
      "V K",
      "Infinity",
      "Chinese",
      "VuTek",
      "Epson",
      "AuraJet",
      "Other Brands",
    ],
  },
  {
    value: "UV Printing",
    brandNames: [
      "Mimaki",
      "FujiFilm",
      "Docan",
      "Keoundo",
      "Chinese",
      "V K",
      "Infinity",
      "Ricoh",
      "HandTop",
      "Other Brands",
    ],
  },

  {
    value: "Solvent Printing",
    brandNames: [
      "AllWin",
      "UltraJet",
      "ColorJet",
      "Grayscale",
      "Konica 512i",
      "V K",
      "Infinity",
      "Mimaki",
      "VuTek",
      "MehtaFlex",
      "I-Jet",
      "Ink-Jet",

      "Other Brands",
    ],
  },
  {
    value: "Digital Printing",
    brandNames: ["HP", "Canon", "Roland", "Other Brands"],
  },
  {
    value: "Plotter Cutting Printing",
    brandNames: [
      "Graphtec",
      "Roland",
      "Saga",
      "Dragon Cut",
      "Chinese",
      "Mimaki",
      "Scy Cut",
      "Other Brands",
    ],
  },
];

const substrate = [
  {
    value: "Ecosolvent Printing",
    type: ["Flex", "Vinyl", "OW vision", "Translit", "Fabric"],
  },
  {
    value: "UV Printing",
    type: [
      "Flex ",
      "Vinyl",
      "OW vision",
      "Translit",
      "Fabric",
      "BlockOut",
      "BacklitFlex",
      "Acrylic",
      "T-shirt",
      "Wallpaper",
    ],
  },
  {
    value: "Digital Printing",
    type: ["Fabric", "Vinyl", "Canvas", "Wallpaper"],
  },
  {
    value: "Solvent Printing",
    type: ["Flex", "Vinyl", "OW vision", "Wallpaper"],
  },
  {
    value: "Plotter Cutting Printing",
    type: ["Vinyl Cutting", "Sticker Cut", "Color Vinyl", "Retro"],
  },
];
const handleKeyPress = (e) => {
  const { name, type } = e.target;
  const charCode = e.keyCode || e.which;

  // Block non-numeric characters for number inputs
  if (
    type === "number" ||
    name === "ownerPrimaryContactNo" ||
    name === "ownerSecondaryContactNo" ||
    name === "pinCode" ||
    name === "numberOfEmployees" ||
    name === "numberOfSkilledManpower" ||
    name === "numberOfUnskilledManpower" ||
    name === "yearsInBusiness" || // Add this
    name === "productionArea" || // Add this
    name === "creditLimit" || // Add this
    name === "avgTurnoverLast3Years" // Add this
  ) {
    // Block 'e', 'E', '+', '-', '.'
    if ([69, 101, 43, 45, 46].includes(charCode)) {
      e.preventDefault();
    }
  }

  // Block special characters in PAN Number (only allow A-Z, 0-9)
  if (name === "PANNumber") {
    const allowedChars = /^[A-Za-z0-9]$/;
    if (!allowedChars.test(e.key)) {
      e.preventDefault();
    }
  }

  // Block numbers in ownerName (only letters)
  if (name === "ownerName" && /[^a-zA-Z\s]/.test(e.key)) {
    e.preventDefault();
  }
};

// Prevent mouse wheel from changing number inputs
const handleWheel = (e) => {
  e.target.blur(); // Remove focus to prevent wheel scroll
};

// Add event listener on focus
const handleFocus = (e) => {
  e.target.addEventListener("wheel", handleWheel, { passive: false });
};

// Remove event listener on blur
const handleBlur = (e) => {
  e.target.removeEventListener("wheel", handleWheel);
};

const VendorOnboardingForm = ({
  isModalOpen,
  setIsModalOpen,
  selectedVendorData,
  setSelectedVendorData,
  getVendorList,
  setSnackbar,
}) => {
  const [categories, setCategories] = useState([]);
  const [productTypeOptions, setProductTypeOptions] = useState({});

  const [formData, setFormData] = useState({
    state: selectedVendorData?.state || "",
    emailAddress: selectedVendorData?.emailAddress || "",
    division: selectedVendorData?.division || "",
    district: selectedVendorData?.district || "",
    city: selectedVendorData?.city || "",
    vendorBusinessName: selectedVendorData?.vendorBusinessName || "",
    pinCode: selectedVendorData?.pinCode || "",
    typeOfBusiness: selectedVendorData?.typeOfBusiness || "",
    ownerName: selectedVendorData?.ownerName || "",
    ownerPrimaryContactNo: selectedVendorData?.ownerPrimaryContactNo || "",
    ownerSecondaryContactNo: selectedVendorData?.ownerSecondaryContactNo || "",
    address: selectedVendorData?.address || "",
    businessLocation: selectedVendorData?.businessLocation || "",
    website: selectedVendorData?.website || "",
    badge: selectedVendorData?.badge || "",
    reliability: selectedVendorData?.reliability || "",
    yearsInBusiness: selectedVendorData?.yearsInBusiness || "",
    numberOfEmployees: selectedVendorData?.numberOfEmployees || "",
    numberOfSkilledManpower: selectedVendorData?.numberOfSkilledManpower || "",
    numberOfUnskilledManpower:
      selectedVendorData?.numberOfUnskilledManpower || "",
    registeredInESIPF: selectedVendorData?.registeredInESIPF || false,
    GSTIN: selectedVendorData?.GSTIN || "",
    PANNumber: selectedVendorData?.PANNumber || "",
    bankAccountNumber: selectedVendorData?.bankAccountNumber || "",
    bankName: selectedVendorData?.bankName || "",
    bankIFSCCode: selectedVendorData?.bankIFSCCode || "",
    avgTurnoverLast3Years: selectedVendorData?.avgTurnoverLast3Years || "",
    productionArea: selectedVendorData?.productionArea || "",
    paymentTerms: selectedVendorData?.paymentTerms || "",
    status: selectedVendorData?.status || "Active",
    auditStatus: selectedVendorData?.auditStatus || "Unverified",
    reasonForBlacklisted: selectedVendorData?.reasonForBlacklisted || "",
    profilePhoto: selectedVendorData?.profilePhoto || "",
    creditLimit: selectedVendorData?.creditLimit || "",

    scalingFactors: selectedVendorData?.scalingFactors || [],
    certifications: selectedVendorData?.certifications || [],
    imagesUploaded: selectedVendorData?.imagesUploaded || [],
    vendorimagesUploaded: selectedVendorData?.vendorimagesUploaded || [],
    chequeBookImageURL: selectedVendorData?.chequeBookImageURL || "",
    certificateUploaded: selectedVendorData?.certificateUploaded || [],
    isPaintingVendorSelected:
      selectedVendorData?.isPaintingVendorSelected || false,
    aadhaarCardNumber: selectedVendorData?.aadhaarCardNumber || "",

    addedBy: localStorage.getItem("userId"),
    updatedBy: localStorage.getItem("userId"),
  });

  const unitOptions = [
    { label: "PCS", value: "PCS" },
    { label: "KGS", value: "KGS" },
    { label: "SQF", value: "SQF" },
    { label: "MTR", value: "MTR" },
  ];

  const [requiredFields, setRequiredFields] = useState({
    state: false,
    division: false,
    city: false,
    vendorBusinessName: false,
    pinCode: false,
    typeOfBusiness: false,
    ownerName: false,
    ownerPrimaryContactNo: false,
    address: false,
    GSTIN: false,
    website: false,
    PANNumber: false,
  });

  // print machine data
  const [PmformData, setPmFormData] = useState({
    machinePrintingType: "",
    machinePrintingSubType: "",
    maxPrintSize: "",
    machineBrand: "",
    horsepower: "",
    substrate: "",
    machineModelNo: "",
    ageOfMachine: "",
    printingCapacityPerDay: "",
    quantity: "",
    picoliter: "",
    PrintingMachineImage: "",
  });
  const [printMachineArray, setPrintMachineArray] = useState(
    selectedVendorData?.printingMachines || [],
  );
  const [PrintingImageModal, setPrintingImageModal] = useState({
    show: false,
    imgSrc: "",
  });
  const [isMachineModalOpen, setIsMachineModalOpen] = useState(false);
  const [isprintMachineEditing, setIsPrintMachineEditing] = useState(false);
  const [printmachineeditIndex, setPrintMachineEditIndex] = useState(null);
  const [pmerror, setPmError] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImage, setIsImage] = useState(false);
  const lengthWidthMapping = {
    8: "4",
    10: "5",
    12: "5",
  };
  const AcrylicWidthMapping = {
    2: "3",
    3: "4",
    8: "4",
  };

  const ChannelBending = {
    5: "3",
    4: "3",
    3: "2",
  };

  const ImageDetails = (e, bool) => {
    setPrintingImageModal((prev) => ({ ...prev, show: bool }));
    setPrintingImageModal((prev) => ({ ...prev, imgSrc: e.target.src }));
  };

  // Fabrication state data
  const [FabformData, setFabFormData] = useState({
    category: "",
    subCategory: "",
    wattage: "",
    ageOfMachine: "",
    numMachines: "",
    breadthInches: "",
    breadthFoot: "",
    lengthFoot: "",
    modelMachine: "",
    machineSize: "",
    machineType: "",
    machineThickness: "",
    machineMaterial: "",
    ampereOfMachine: "",
    powerOfMachine: "",
    controllerSetting: "",
    horsepower: "",
    machineModelNo: "",
    fabricationMachineImage: "",
  });

  const [deleteImages, setDeleteImages] = useState([]);

  // Determine which mapping to use based on the selected category
  const getMapping = () => {
    if (FabformData.category === "CNC Router Machine")
      return lengthWidthMapping;
    if (FabformData.category === "Acrylic Laser Cutting Machine")
      return AcrylicWidthMapping;
    if (FabformData.category === "Channel Letter Bending Machine")
      return ChannelBending;

    return {};
  };

  const [fabArray, setFabArray] = useState(
    selectedVendorData?.fabricationMachines || [],
  );

  const [fabImageModal, setFabImageModal] = useState(false);
  const [isfabModalOpen, setIsFabModalOpen] = useState(false);
  const [isfabEditing, setIsFabEditing] = useState(false);
  const [fabeditIndex, setFabEditIndex] = useState(null);
  // product and Services
  const [ProductformData, setProductFormData] = useState({
    fabrication: false,
    typesOfFabrication: [],
    printingProducts: false,
    typesOfPrintingProducts: [],
    paintingProducts: false,
    typesofPaintingProducts: [],
  });
  const [productArray, setProductArray] = useState(
    selectedVendorData?.productAndServices || [],
  );
  const [pricingRows, setPricingRows] = useState(
    selectedVendorData?.productRate?.length
      ? selectedVendorData.productRate
      : [
          {
            category: "",
            productType: "",
            unit: "",
            rate: "",
          },
        ],
  );
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [isProductEditing, setIsProductEditing] = useState(false);
  const [productEditIndex, setProductEditIndex] = useState(null);

  // other
  const cityApiKey = process.env.REACT_APP_FETCH_STATE_CITY_API_KEY;
  const [cityArray, setCityArray] = useState([]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.state) newErrors.state = "State is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.vendorBusinessName)
      newErrors.vendorBusinessName = "Business Name is required";
    if (!formData.pinCode || !/^\d{6}$/.test(formData.pinCode))
      newErrors.pinCode = "Valid Pin Code is required";
    if (!formData.isPaintingVendorSelected) {
      if (!formData.typeOfBusiness)
        newErrors.typeOfBusiness = "Business Type is required";
    }
    if (!formData.ownerName) newErrors.ownerName = "Owner Name is required";
    if (
      !formData.ownerPrimaryContactNo ||
      !/^\d{10}$/.test(formData.ownerPrimaryContactNo)
    )
      newErrors.ownerPrimaryContactNo = "Valid Contact No is required";
    if (
      formData.ownerSecondaryContactNo &&
      !/^\d{10}$/.test(formData.ownerSecondaryContactNo)
    )
      newErrors.ownerSecondaryContactNo =
        "Valid Secondary Contact No is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (
      formData.website &&
      !/^(https?:\/\/)?([\w\d]+\.)?[\w\d]+\.\w+/.test(formData.website)
    )
      newErrors.website = "Valid Website URL is required";
    if (!formData.isPaintingVendorSelected) {
      if (!formData.GSTIN || formData.GSTIN.length < 15) {
        newErrors.GSTIN = "Enter the valid GSTIN";
      }
    }

    if (
      formData?.aadhaarCardNumber &&
      formData?.aadhaarCardNumber?.length < 12
    ) {
      newErrors.aadhaarCardNumber = "Enter the valid aadhaar Number";
    }

    if (formData.PANNumber && !/^\w{10}$/.test(formData.PANNumber))
      newErrors.PANNumber = "PAN Number is not valid";

    if (formData.status === "Blacklisted" && !formData.reasonForBlacklisted)
      newErrors.reasonForBlacklisted = "Please enter a reason for blacklist";
    if (!formData.isPaintingVendorSelected) {
      // if (!formData.emailAddress) newErrors.emailAddress = "Please enter email";
      if (!formData.isPaintingVendorSelected) {
        if (formData.certifications && formData.certifications.length > 0) {
          const missingCertificates = formData.certifications.filter(
            (cert) => !cert.photo || cert.photo.length === 0,
          );

          if (missingCertificates.length > 0) {
            newErrors.certifications =
              "Please upload certificates for all selected certifications";
          }
        }
      }
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [loading, setLoading] = useState(false); // loading state for API calls
  // const [isGstVerified, setIsGstVerified] = useState(false);
  const [isGstVerified, setIsGstVerified] = useState(
    formData?.GSTIN?.length === 15,
  );

  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const serverURL = process.env.REACT_APP_URL;
  useEffect(() => {
    const stateCode = statecityData.find(
      (ele) => ele.name === formData.state,
    )?.iso2;

    if (formData.state) {
      const fetchCities = async (stateCode) => {
        const headers = new Headers();
        headers.append("X-CSCAPI-KEY", cityApiKey);

        const requestOptions = {
          method: "GET",
          headers: headers,
          redirect: "follow",
        };

        try {
          const response = await fetch(
            `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
            requestOptions,
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const cityData = await response.json();
          setCityArray(cityData);

          // Log the city names
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      // Example usage: Fetch cities in Maharashtra (state code "MH")
      fetchCities(stateCode);
    }
  }, [formData.state]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${serverURL}/itemMaster/categories`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const categoryOptions = response.data.data;
        const formattedCategoryOptions = categoryOptions.map((item) => ({
          label: item.category,
          value: item.category,
        }));
        setCategories(formattedCategoryOptions);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);
  const handleCategoryChange = async (category) => {
    try {
      const res = await fetch(
        `${serverURL}/itemMaster/product-types?categories=${category}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const json = await res.json();
      const data = json.data || [];

      const formatted = data.map((item) => ({
        label: item,
        value: item,
      }));

      setProductTypeOptions({
        [category]: formatted,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const fetchDetailsThroughGSTIN = async (gstNumber) => {
    setLoading(true);
    const responseData = await verifyGST(gstNumber);
    setLoading(false);

    if (responseData.error) {
      setErrors({ ...errors, GSTIN: "Enter valid GSTIN" });
      setIsGstVerified(false);
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData, // Keep previous form data, including `gstin`
        GSTIN: gstNumber, // Ensure `gstin` remains intact
        state: responseData?.taxpayerInfo?.pradr?.addr?.stcd || "",

        pinCode: responseData?.taxpayerInfo?.pradr?.addr?.pncd || "",
        vendorBusinessName: capitalizeWords(
          responseData?.taxpayerInfo?.tradeNam || "",
        ),
        address: capitalizeWords(
          [
            responseData?.taxpayerInfo?.pradr?.addr?.flno,
            responseData?.taxpayerInfo?.pradr?.addr?.bno,
            responseData?.taxpayerInfo?.pradr?.addr?.st,
            responseData?.taxpayerInfo?.pradr?.addr?.landMark,
            responseData?.taxpayerInfo?.pradr?.addr?.locality,
            responseData?.taxpayerInfo?.pradr?.addr?.loc,
          ]
            .filter(Boolean)
            .join(", "),
        ),
        city: responseData?.taxpayerInfo?.pradr?.addr?.dst,
      }));
      setIsGstVerified(true);
    }
  };

  // handlers

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setErrors({ ...errors, GSTIN: "" });
    // setIsGstVerified(false);
    // Using a single state update with the callback function to ensure state consistency
    setFormData((prevFormData) => {
      let updatedValue = value;

      // 🔥 Apply capitalization to selected fields
      const capitalizeFields = ["address"];

      if (capitalizeFields.includes(name)) {
        updatedValue = capitalizeWords(value);
      }

      const updatedData = { ...prevFormData, [name]: updatedValue };

      // Handle clearing related fields based on the current input
      if (name === "state") {
        updatedData.city = "";
        updatedData.district = "";
      }

      return updatedData;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      // Gst validation
      if (name === "GSTIN" && value.length === 15) {
        fetchDetailsThroughGSTIN(value.toUpperCase());
      }

      return newErrors;
    });
  };

  const emptyInputCheck = (fieldName, value) => {
    if (value === "") {
      setRequiredFields({ ...requiredFields, [fieldName]: true });
    } else {
      setRequiredFields({ ...requiredFields, [fieldName]: false });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text: "Something Went Wrong",
        color: "black",
      });
    } else {
      try {
        const deleteImagesArray = deleteImages.filter(Boolean);
        if (deleteImagesArray.length > 0) {
          const deleteResponse = await axios.post(
            `${serverURL}/deleteUpload`,
            { keys: deleteImagesArray },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          );
        }

        if (selectedVendorData._id) {
          // Update existing vendor
          try {
            const updatedFormData = {
              ...formData,
              // Here you can add any additional fields or modifications needed
              printingMachines: printMachineArray, // Assuming you want to update who made the change
              productAndServices: productArray,
              fabricationMachines: fabArray,
              productRate: pricingRows.filter(
                (item) =>
                  item.category?.trim() ||
                  item.productType?.trim() ||
                  item.unit?.trim() ||
                  item.rate,
              ),
            };
            setIsLoading(true);
            const response = await axios.put(
              `${serverURL}/api/vendors/${selectedVendorData._id}`,
              updatedFormData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              },
            );

            if (response.data.success) {
              setIsModalOpen(false);
              getVendorList();
            } else {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "error",
                text: response.data.error,
                padding: "1em",
                color: "black",
              });
            }
          } catch (error) {
            console.error("Error updating vendor:", error);
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "error",
              title: error.response.data.message,
              text: `Error in updating vendor: ${formData.vendorBusinessName}!`,
              padding: "1em",
            });
          }
        } else {
          // Create new vendor
          try {
            const updatedFormData = {
              ...formData,
              // Here you can add any additional fields or modifications needed
              printingMachines: printMachineArray, // Assuming you want to update who made the change
              productAndServices: productArray,
              fabricationMachines: fabArray,
              productRate: pricingRows.filter(
                (item) =>
                  item.category?.trim() ||
                  item.productType?.trim() ||
                  item.unit?.trim() ||
                  item.rate,
              ),
              onboardedBy: "web",
            };
            setIsLoading(true);
            const response = await axios.post(
              `${serverURL}/api/vendors`,
              updatedFormData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              },
            );
            if (response.data.success) {
              setSnackbar({
                open: true,
                message: response.data.message,
                severity: "success",
              });

              setIsModalOpen(false);
              getVendorList();
            } else {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "error",
                text: response.data.error,
                padding: "1em",
                color: "black",
              });
            }
          } catch (error) {
            console.error("Error creating vendor:", error);
            setIsLoading(true);
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "error",
              title: error.response.data.message,
              text: `Error in creating vendor !`,

              color: "black",
            });
          }
        }
      } catch (globalError) {
        setIsLoading(true);
        console.error("Unexpected error:", globalError);
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error",
          title: "Oops...",
          text: "An unexpected error occurred!",
          padding: "1em",
          color: "red",
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  // Callback to handle uploaded file URLs
  const handleFilesUpload = (urls) => {
    setFormData({
      ...formData,
      imagesUploaded: urls, // Store the image as a Data URL for preview
    });
  };

  const handleVendorFilesUpload = (urls) => {
    setFormData({
      ...formData,
      vendorimagesUploaded: urls, // Store the image as a Data URL for preview
    });
  };
  const handleChequeFilesUpload = (urls) => {
    setFormData({
      ...formData,
      chequeBookImageURL: urls, // Store the image as a Data URL for preview
    });
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedVendorData({});
  };
  const handleModalOpen = (e) => {
    e.preventDefault();
    setIsMachineModalOpen(true);
  };

  // printing machine
  const handleMachineModalClose = () => {
    setPmFormData({
      machinePrintingType: "",
      machinePrintingSubType: "",
      maxPrintSize: "",
      machineBrand: "",
      substrate: "",
      machineModelNo: "",
      ageOfMachine: "",
      printingCapacityPerDay: "",
      quantity: "",
      PrintingMachineImage: "",
    });
    setIsPrintMachineEditing(null);
    setIsMachineModalOpen(false);
  };

  // Handle input changes
  const [isOtherSelected, setIsOtherSelected] = useState(false);

  const handleMachineChange = (e) => {
    const { name, value } = e.target;

    setPmFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "machinePrintingType" && {
        machinePrintingSubType: "",
        machineBrand: "",
        substrate: "",
        PrintingMachineImage: "",
        ageOfMachine: "",
      }),
    }));

    if (name === "machineBrand" && value === "Other Brands") {
      setIsOtherSelected(true);
      setPmFormData((prev) => ({ ...prev, machineBrand: "" })); // Reset `machineBrand`
    } else if (name === "machinePrintingType") {
      setIsOtherSelected(false);
    }
  };

  const handleMachineEdit = (e, index, item) => {
    const machineToEdit = printMachineArray[index];
    setPmFormData({
      machinePrintingType: machineToEdit.machinePrintingType,
      machinePrintingSubType: machineToEdit.machinePrintingSubType,
      maxPrintSize: machineToEdit.maxPrintSize,
      picoliter: machineToEdit.picoliter,
      machineBrand: machineToEdit.machineBrand,
      substrate: machineToEdit.substrate,
      machineModelNo: machineToEdit.machineModelNo,
      ageOfMachine: machineToEdit.ageOfMachine,
      printingCapacityPerDay: machineToEdit.printingCapacityPerDay,
      quantity: machineToEdit.quantity,
      PrintingMachineImage: machineToEdit.PrintingMachineImage,
    });
    setIsPrintMachineEditing(true);
    setPrintMachineEditIndex(index);
    // Open the modal if you are using one for editing
    setIsMachineModalOpen(true);
  };
  const handleMachineDelete = (e, index, item) => {
    const deletedItem = printMachineArray[index]; // get the item being deleted

    // Add its image to deleteImages (for backend cleanup if needed)
    if (deletedItem?.PrintingMachineImage) {
      setDeleteImages((prev) => [...prev, deletedItem.PrintingMachineImage]);
    }

    // Remove the fabrication entry from the array
    const updatedPrintArray = printMachineArray?.filter((_, i) => i !== index);
    setPrintMachineArray(updatedPrintArray);
    // Reset editing state if the deleted one was being edited
    if (printmachineeditIndex === index) {
      setIsPrintMachineEditing(false);
      setPrintMachineEditIndex(null);
    }
  };

  const handleMachineSubmit = (e) => {
    e.preventDefault();

    // Check if the ageOfMachine field is empty
    if (!PmformData.ageOfMachine) {
      setPmError(true);
    } else {
      // Safely format the date if it exists

      const newMachine = {
        machinePrintingType: PmformData.machinePrintingType,
        machinePrintingSubType: PmformData.machinePrintingSubType,
        maxPrintSize: PmformData.maxPrintSize,
        picoliter: PmformData.picoliter,
        machineBrand: PmformData.machineBrand,
        substrate: PmformData.substrate,
        machineModelNo: PmformData.machineModelNo,
        ageOfMachine: PmformData.ageOfMachine, // This can be null if no date is selected
        printingCapacityPerDay: PmformData.printingCapacityPerDay,
        PrintingMachineImage: PmformData.PrintingMachineImage,
        quantity: PmformData.quantity,
      };

      if (isprintMachineEditing) {
        // Update the existing machine in the array
        const updatedMachines = [...printMachineArray];
        updatedMachines[printmachineeditIndex] = newMachine;
        const previousArr = [...printMachineArray];

        const updatedPrinting = [...printMachineArray];

        updatedPrinting[printmachineeditIndex] = newMachine;

        const imageChanged =
          previousArr[printmachineeditIndex].PrintingMachineImage !==
          updatedPrinting[printmachineeditIndex].PrintingMachineImage;

        if (imageChanged) {
          setDeleteImages((prev) => [
            ...prev,
            previousArr[printmachineeditIndex].PrintingMachineImage,
          ]);
        }
        setPrintMachineArray(updatedMachines);
        setIsPrintMachineEditing(false);
        setPrintMachineEditIndex(null);
      } else {
        // Add a new machine to the array
        setPrintMachineArray([...printMachineArray, newMachine]);
      }

      // Clear form fields after submission
      setPmFormData({
        machinePrintingType: "",
        machinePrintingSubType: "",
        maxPrintSize: "",
        picoliter: "",
        machineBrand: "",
        substrate: "",
        machineModelNo: "",
        ageOfMachine: "", // Reset date to null
        printingCapacityPerDay: "",
        quantity: "",
        PrintingMachineImage: "",
      });

      // Optionally close the modal if you're using one
      setIsMachineModalOpen(false);
      setPmError(false);
    }
  };

  // fabrication

  const handleFabModalOpen = () => {
    setIsFabModalOpen(true);
  };
  const handleFabChange = (e) => {
    const { name, value } = e.target;

    setFabFormData((prev) => {
      const updatedFormData = {
        ...prev,
        [name]: value,
      };
      // Reset subCategory and machineBrand when category changes
      if (name === "category") {
        updatedFormData.subCategory = "";
        updatedFormData.machineBrand = "";
        updatedFormData.fabricationMachineImage = "";
        updatedFormData.machineType = "";
        updatedFormData.machineThickness = "";
        updatedFormData.machineMaterial = "";
        setIsOtherSelected(false);
      }
      if (name === "lengthFoot") {
        const mapping = getMapping();
        updatedFormData.breadthFoot = mapping[value] || "";
      }

      // Reset machineBrand if "Other" is selected
      if (name === "machineBrand" && value === "Other Brands") {
        setIsOtherSelected(true);
        updatedFormData.machineBrand = "";
      }

      // Append unit to machineBreadth if unitBreadth is selected
      if (name === "unitBreadth" && updatedFormData.machineBreadth) {
        updatedFormData.machineBreadth = `${prev.machineBreadth.replace(
          / feet| inch/,
          "",
        )} ${value}`;
      }
      if (name === "unitLength" && updatedFormData.machineLength) {
        updatedFormData.machineLength = `${prev.machineLength.replace(
          / feet| inch/,
          "",
        )} ${value}`;
      }
      if (name === "machineLength") {
        updatedFormData.unitLength = "";
      }

      if (name === "machineBreadth") {
        updatedFormData.unitBreadth = "";
      }

      return updatedFormData;
    });
  };

  const handleImageClick = (imageSrc) => {
    setIsImage(true);
    setSelectedImage(imageSrc); // Set the clicked image's source
    // Show the modal
  };

  const handleFabSubmit = (e) => {
    e.preventDefault();

    const newFabrication = {
      category: FabformData.category,
      subCategory: FabformData.subCategory,
      machineSize: FabformData.machineSize,
      wattage: FabformData.wattage,
      horsepower: FabformData.horsepower,
      ageOfMachine: FabformData.ageOfMachine,
      numMachines: FabformData.numMachines,
      lengthFoot: FabformData.lengthFoot,
      modelMachine: FabformData.modelMachine,
      fabricationMachineImage: FabformData.fabricationMachineImage,
      machineType: FabformData.machineType,
      machineThickness: FabformData.machineThickness,
      machineMaterial: FabformData.machineMaterial,

      breadthInches: FabformData.breadthInches,
      breadthFoot: FabformData.breadthFoot,
      unitBreadth: FabformData.unitBreadth,
      unitLength: FabformData.unitLength,
      ampereOfMachine: FabformData.ampereOfMachine,
      powerOfMachine: FabformData.powerOfMachine,
      controllerSetting: FabformData.controllerSetting,
    };

    if (isfabEditing) {
      // Update the existing machine in the array
      const previousArr = [...fabArray];

      const updatedFabrication = [...fabArray];

      updatedFabrication[fabeditIndex] = newFabrication;

      const imageChanged =
        previousArr[fabeditIndex].fabricationMachineImage !==
        updatedFabrication[fabeditIndex].fabricationMachineImage;

      if (imageChanged) {
        setDeleteImages((prev) => [
          ...prev,
          previousArr[fabeditIndex].fabricationMachineImage,
        ]);
      }
      setFabArray(updatedFabrication);
      setIsFabEditing(false);
      setFabEditIndex(null);
    } else {
      // Add a new machine to the array
      setFabArray([...fabArray, newFabrication]);
    }

    // Optionally close the modal if you're using one

    setFabFormData({
      category: "",
      machineSize: "",
      subCategory: "",
      wattage: "",
      ageOfMachine: "",
      horsepower: "",
      numMachines: "",
      machineType: "",
      machineThickness: "",
      machineMaterial: "",
      lengthFoot: "",
      modelMachine: "",
      breadthInches: "",
      breadthFoot: "",
      unitBreadth: "",
      unitLength: "",
      fabricationMachineImage: "",
      ampereOfMachine: "",
      powerOfMachine: "",
      controllerSetting: "",
    });
    setIsFabModalOpen(false);
  };
  const handleFabModalClose = () => {
    setFabFormData({
      category: "",
      machineSize: "",
      subCategory: "",
      wattage: "",
      ageOfMachine: "",
      horsepower: "",
      numMachines: "",
      machineLength: "",
      machineType: "",
      machineThickness: "",
      machineMaterial: "",
      machineInches: "",
      breadthInches: "",
      breadthFoot: "",
      unitBreadth: "",
      unitLength: "",
      ampereOfMachine: "",
      powerOfMachine: "",

      controllerSetting: "",

      fabricationMachineImage: "",
    });
    setIsFabModalOpen(false);
    setIsFabEditing(false);
  };
  const handleMainCategoryChange = (e) => {
    setFabFormData((prevData) => ({
      ...prevData,
      category: e.target.value,
      subCategory: "", // Reset sub-category when main category changes
      wattage: "",
      ageOfMachine: "",
      machineType: "",
      machineThickness: "",
      machineMaterial: "",
      machineSize: "",
      numMachines: "",
      horsepower: "",
      lengthFoot: "",
      modelMachine: "",
      breadthFoot: "",
      breadthInches: "",
      unitBreadth: "",
      unitLength: "",
      fabricationMachineImage: "",
      controllerSetting: "",
      powerOfMachine: "",
      ampereOfMachine: "",
    }));
    if (e.target.name === "category") {
      setIsOtherSelected(false);
    }
  };
  const handleFabricationEdit = (e, index, item) => {
    const fabToEdit = fabArray[index];

    setFabFormData({
      category: fabToEdit.category,
      machineSize: fabToEdit.machineSize,
      numMachines: fabToEdit.numMachines,
      lengthFoot: fabToEdit.lengthFoot,
      modelMachine: fabToEdit.modelMachine,
      breadthFoot: fabToEdit.breadthFoot,
      breadthInches: fabToEdit.breadthInches,
      fabricationMachineImage: fabToEdit.fabricationMachineImage,
      machineType: fabToEdit.machineType,
      machineThickness: fabToEdit.machineThickness,
      machineMaterial: fabToEdit.machineMaterial,

      subCategory: fabToEdit.subCategory,
      horsepower: fabToEdit.horsepower,
      wattage: fabToEdit.wattage,
      ageOfMachine: fabToEdit.ageOfMachine,
      ampereOfMachine: fabToEdit.ampereOfMachine,
      powerOfMachine: fabToEdit.powerOfMachine,
      controllerSetting: fabToEdit.controllerSetting,
    });
    setIsFabEditing(true);
    setFabEditIndex(index);
    // Open the modal if you are using one for editing
    setIsFabModalOpen(true);
  };
  const handleFabricationDelete = (e, index, item) => {
    const deletedItem = fabArray[index]; // get the item being deleted

    // Add its image to deleteImages (for backend cleanup if needed)
    if (deletedItem?.fabricationMachineImage) {
      setDeleteImages((prev) => [...prev, deletedItem.fabricationMachineImage]);
    }

    // Remove the fabrication entry from the array
    const updatedFabArray = fabArray?.filter((_, i) => i !== index);
    setFabArray(updatedFabArray);

    // Reset editing state if the deleted one was being edited
    if (fabeditIndex === index) {
      setIsFabEditing(false);
      setFabEditIndex(null);
    }
  };
  const handleKeyPress = (e) => {
    const { name, type } = e.target;
    const charCode = e.keyCode || e.which;

    if (name === "userName") {
      if (/[^a-zA-Z\s]/.test(e.key)) {
        e.preventDefault();
      }
    } else if (type === "number" || name === "userPhoneNumber") {
      if ([69, 101, 43, 45, 46].includes(charCode)) {
        e.preventDefault();
      }
    }
  };

  // product and services
  const handleProductChange = (event) => {
    const { name, value, checked } = event.target;

    setProductFormData((prevData) => {
      // Handle fabrication checkbox
      if (name === "fabrication") {
        return {
          ...prevData,
          fabrication: value,
          typesOfFabrication: checked ? prevData.typesOfFabrication : [],
        };
      }

      if (name === "printingProducts") {
        return {
          ...prevData,
          printingProducts: value,
          typesOfPrintingProducts: checked
            ? prevData.typesOfPrintingProducts
            : [],
        };
      }

      if (name === "paintingProducts") {
        return {
          ...prevData,
          paintingProducts: value,
          typesOfPaintingProducts: checked
            ? prevData.typesOfPaintingProducts
            : [],
        };
      }
      // Handle other fields
      return {
        ...prevData,
        [name]: value,
      };
    });
  };

  const handleProductModalOpen = () => {
    setIsProductModalOpen(true);
  };
  const handleProductModalClose = () => {
    setProductFormData({
      fabrication: false,
      typesOfFabrication: [],
      printingProducts: false,
      typesOfPrintingProducts: [],
      paintingProducts: false,
      typesOfPaintingProducts: [],
    });
    setIsProductEditing(false);
    setIsProductModalOpen(false);
  };
  const handleProductEdit = (e, index, item) => {
    const productToEdit = productArray[index];
    setProductFormData({
      fabrication: productToEdit.fabrication,
      typesOfFabrication: productToEdit.typesOfFabrication,
      printingProducts: productToEdit.printingProducts,
      typesOfPrintingProducts: productToEdit.typesOfPrintingProducts,
      paintingProducts: productToEdit.paintingProducts,
      typesOfPaintingProducts: productToEdit.typesOfPaintingProducts,
    });
    setIsProductEditing(true);
    setProductEditIndex(index);
    // Open the modal if you are using one for editing
    setIsProductModalOpen(true);
  };
  const handleProductDelete = (e, index, item) => {
    const updatedArray = [...productArray]; // Copy the array
    updatedArray.splice(index, 1); // Remove the item at the specified index
    setProductArray(updatedArray);
  };

  const handleProductSubmit = (e) => {
    e.preventDefault();
    if (
      ProductformData.fabrication &&
      (!ProductformData.typesOfFabrication ||
        ProductformData.typesOfFabrication.length === 0)
    ) {
      setSnackbar({
        open: true,
        message: "Select atleast one Fabrication Product",
        severity: "error",
      });
      return;
    }
    if (
      ProductformData.printingProducts &&
      (!ProductformData.typesOfPrintingProducts ||
        ProductformData.typesOfPrintingProducts.length === 0)
    ) {
      setSnackbar({
        open: true,
        message: "Select atleast one Printing Product",
        severity: "error",
      });
      return;
    }
    if (
      ProductformData.paintingProducts &&
      (!ProductformData.typesOfPaintingProducts ||
        ProductformData.typesOfPaintingProducts.length === 0)
    ) {
      setSnackbar({
        open: true,
        message: "Select atleast one Painting Product",
        severity: "error",
      });
      return;
    }

    const newProduct = {
      fabrication: ProductformData.fabrication,
      typesOfFabrication: ProductformData.typesOfFabrication,
      typesOfPrintingProducts: ProductformData.typesOfPrintingProducts,
      printingProducts: ProductformData.printingProducts,
      typesOfPaintingProducts: ProductformData.typesOfPaintingProducts,
      paintingProducts: ProductformData.paintingProducts,
    };

    if (isProductEditing) {
      const updatedProduct = [...productArray];
      updatedProduct[productEditIndex] = newProduct;
      setProductArray(updatedProduct);
      setIsProductEditing(false);
      setProductEditIndex(null);
    } else {
      // Add a new machine to the array
      setProductArray([...productArray, newProduct]);
    }

    setProductFormData({
      fabrication: false,
      typesOfFabrication: [],
      printingProducts: false,
      typesOfPrintingProducts: [],
      paintingProducts: false,
      typesOfPaintingProducts: [],
    });

    setIsProductModalOpen(false);
  };

  const handleCertificationChange = (event) => {
    const selectedLabels = event.target.value; // Array of selected certification names (["3M", "LG"])

    setFormData((prevData) => ({
      ...prevData,
      certifications: selectedLabels.map((label) => {
        const existingCert = prevData.certifications.find(
          (cert) => cert.label === label,
        );
        return existingCert ? existingCert : { label, photo: [] }; // Ensure photo is an array
      }),
    }));

    if (errors.certifications) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.certifications;
        return newErrors;
      });
    }
  };

  // certification file
  const handleFilesUploadCertificate = (label, urls) => {
    setFormData((prevData) => ({
      ...prevData,
      certifications: prevData.certifications.map((cert) =>
        cert.label === label ? { ...cert, photo: urls } : cert,
      ),
    }));
  };

  const handleAddRow = () => {
    setPricingRows((prev) => [
      ...prev,
      {
        category: "",
        productType: "",
        unit: "",
        rate: "",
      },
    ]);
  };

  return (
    <div>
      <Dialog open={isModalOpen} maxWidth="xl" fullWidth>
        <div className={`flex justify-between ${Styles.vendorModalColor}`}>
          <DialogTitle className={Styles.vendorHeading}>
            Vendor Details
          </DialogTitle>
          <div
            className="mx-5 my-4 flex justify-around items-center"
            style={{ cursor: "pointer" }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.isPaintingVendorSelected}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      isPaintingVendorSelected: e.target.checked,
                    }))
                  }
                  color="primary"
                />
              }
              label="GSTIN Unregistered"
            />
            <div onClick={handleClose}>
              <Cross />
            </div>
          </div>
        </div>
        <DialogContent className={Styles.vendorModalColor}>
          <form onSubmit={handleSubmit}>
            {localStorage.getItem("role") != 0 && (
              <div className={Styles.formstyling}>
                <Grid container spacing={6}>
                  <Grid item xs={12} sm={6} md={4}>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <CustomInput
                        placeholder="Enter GSTIN"
                        title={`GSTIN${
                          formData.isPaintingVendorSelected ? "" : " *"
                        }`}
                        size="small"
                        name="GSTIN"
                        value={formData?.GSTIN.toUpperCase()}
                        onChange={(e) => {
                          if (
                            !e.target.value.startsWith(" ") &&
                            e?.target?.value.length < 16
                          ) {
                            handleInputChange(e);
                          }
                        }}
                        errorMessage={
                          errors.GSTIN ? (
                            <span style={{ color: "var(--error-color)" }}>
                              Please Enter GSTIN
                            </span>
                          ) : null
                        }
                        error={errors.GSTIN}
                      />

                      {loading ? (
                        <div
                          style={{
                            position: "absolute",
                            top: "70%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            width: "20px",
                            height: "20px",
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <CircularProgress color="inherit" size={20} />
                        </div>
                      ) : errors.GSTIN ? (
                        <div
                          style={{
                            position: "absolute",
                            top: "53%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            width: "20px",
                            height: "20px",
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Cross
                            color="var(--error-color)"
                            fillcolor="var(--error-color)"
                          />
                        </div>
                      ) : isGstVerified ? (
                        <div
                          style={{
                            position: "absolute",
                            top: "70%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            width: "20px",
                            height: "20px",
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <VerifiedTick
                            color="var(--third-color)"
                            fillcolor="var(--third-color)"
                          />
                        </div>
                      ) : null}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      fullWidth
                      name="vendorBusinessName"
                      placeholder="Enter Vendor Business Name"
                      title="Vendor Business Name *"
                      size="small"
                      required
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      errorMessage={
                        errors.vendorBusinessName ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please Enter Vendor's Business Name
                          </span>
                        ) : null
                      }
                      error={errors.vendorBusinessName}
                      value={formData?.vendorBusinessName}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Business Address"
                      name="address"
                      title="Business Address *"
                      size="small"
                      multiline
                      required
                      value={formData?.address}
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      errorMessage={
                        errors.address ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please Enter Address
                          </span>
                        ) : null
                      }
                      error={errors.address}
                      // disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <GlobalDropdownField
                      name="state"
                      label="State *"
                      value={formData?.state?.name || formData?.state}
                      onChange={handleInputChange}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      search={true}
                      placeholder="State"
                      options={statecityData.map((state) => ({
                        value: state.name,
                        label: state.name,
                      }))}
                      variant="citySelect"
                      error={errors.state}
                      errorMessage={errors.state}
                      renderValueFn={(selected) =>
                        selected ? (
                          selected
                        ) : (
                          <p
                            style={{
                              color: "var(--light-gray)",
                              fontSize: "1rem",
                            }}
                          >
                            State
                          </p>
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <GlobalDropdownField
                      name="city"
                      label="City *"
                      search={true}
                      value={formData?.city || ""}
                      onChange={handleInputChange}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      placeholder="City"
                      options={cityArray.map((c) => ({
                        value: c.name,
                        label: c.name,
                      }))}
                      variant="citySelect"
                      error={errors.city}
                      errorMessage={errors.city}
                      renderValueFn={(selected) =>
                        selected?.length === 0 || !selected ? (
                          <p
                            style={{
                              color: "var(--light-gray)",
                              fontSize: "1rem",
                            }}
                          >
                            City
                          </p>
                        ) : (
                          selected
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Pincode"
                      name="pinCode"
                      title="Pin Code *"
                      type="number"
                      size="small"
                      required
                      value={formData?.pinCode}
                      onChange={(e) => {
                        if (
                          !e.target.value.startsWith(" ") &&
                          e.target.value.length < 7
                        ) {
                          handleInputChange(e);
                        }
                      }}
                      onKeyPress={(e) => handleKeyPress(e)} // Blocks non-numeric characters
                      onFocus={handleFocus} // Prevents mouse wheel changes
                      onBlur={(e) => {
                        handleBlur(e);
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      errorMessage={
                        errors.pinCode ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please Enter PinCode
                          </span>
                        ) : null
                      }
                      error={errors.pinCode}
                      InputProps={{
                        inputProps: {
                          min: 0,
                          maxLength: 6,
                        },
                      }}
                    />
                  </Grid>
                  {!formData.isPaintingVendorSelected && (
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput
                        name="district"
                        placeholder="Enter District"
                        title="District"
                        size="small"
                        value={formData?.district}
                        onChange={(e) => {
                          if (!e.target.value.startsWith(" ")) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={(e) => {
                          emptyInputCheck(e.target.name, e.target.value);
                          if (saveButtonClicked) {
                            validateForm();
                          }
                        }}
                      />
                    </Grid>
                  )}
                  {!formData.isPaintingVendorSelected && (
                    <Grid item xs={12} sm={6} md={4}>
                      <GlobalDropdownField
                        name="typeOfBusiness"
                        label="Type of Business *"
                        value={formData?.typeOfBusiness}
                        onChange={handleInputChange}
                        onBlur={(e) => {
                          emptyInputCheck(e.target.name, e.target.value);
                          if (saveButtonClicked) validateForm();
                        }}
                        placeholder="Choose Type Of Business"
                        error={errors.typeOfBusiness}
                        errorMessage={errors.typeOfBusiness}
                        options={[
                          {
                            value: "One Person Company",
                            label: "One Person Company",
                          },
                          {
                            value: "Sole Proprietor",
                            label: "Sole Proprietor",
                          },
                          { value: "Partnership", label: "Partnership" },
                          {
                            value: "Foreign Company",
                            label: "Foreign Company",
                          },
                          { value: "LLP", label: "LLP" },
                          {
                            value: "Private Limited Company",
                            label: "Private Limited Company",
                          },
                          {
                            value: "Limited Company",
                            label: "Limited Company",
                          },
                        ]}
                        renderValueFn={(selected) =>
                          selected ? (
                            selected
                          ) : (
                            <p className="text-[1rem] text-[var(--light-gray)]">
                              Choose Type Of Business
                            </p>
                          )
                        }
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Owner's Name"
                      title="Owner Name *"
                      size="small"
                      name="ownerName"
                      required
                      value={formData?.ownerName}
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      errorMessage={
                        errors.ownerName ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please Enter Owner's Name
                          </span>
                        ) : null
                      }
                      error={errors.ownerName}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Owner's Primary Contact Number"
                      title="Owner Primary Contact Number *"
                      type="number"
                      name="ownerPrimaryContactNo"
                      size="small"
                      required
                      value={formData?.ownerPrimaryContactNo}
                      onChange={(e) => {
                        if (
                          !e.target.value.startsWith(" ")
                          //  &&
                          // e.target.value.length < 11
                        ) {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={(e) => {
                        emptyInputCheck(e.target.name, e.target.value);
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      onKeyPress={
                        (e) => handleKeyPress(e)
                        // Check for restricted characters and prevent default behavior if matched
                      }
                      errorMessage={
                        errors.ownerPrimaryContactNo ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please Enter a valid Phone Number
                          </span>
                        ) : null
                      }
                      error={errors.ownerPrimaryContactNo}
                      InputProps={{ inputProps: { min: 0 } }}
                      onFocus={handleFocus}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Owner Secondary Contact Number"
                      title="Owner Secondary Contact No"
                      type="number"
                      size="small"
                      name="ownerSecondaryContactNo"
                      error={errors.ownerSecondaryContactNo}
                      errorMessage={
                        errors.ownerSecondaryContactNo ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please Enter a valid Phone Number
                          </span>
                        ) : null
                      }
                      value={formData?.ownerSecondaryContactNo}
                      onBlur={() => {
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      onKeyPress={
                        (e) => handleKeyPress(e)
                        // Check for restricted characters and prevent default behavior if matched
                      }
                      onChange={(e) => {
                        if (
                          !e.target.value.startsWith(" ")
                          // &&
                          // e.target.value.length < 11
                        ) {
                          handleInputChange(e);
                        }
                      }}
                      InputProps={{ inputProps: { min: 0 } }}
                      onFocus={handleFocus}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Email Address"
                      // title={`Email Address
                      //   ${
                      //   formData.isPaintingVendorSelected ? "" : " *"
                      // }
                      // `}
                      title="Email Address"
                      name="emailAddress"
                      size="small"
                      value={formData?.emailAddress}
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e);
                        }
                      }}
                      errorMessage={
                        errors.emailAddress ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please enter a valid email address
                          </span>
                        ) : null
                      }
                      error={errors.emailAddress}
                      onBlur={(e) => {
                        // Optional email validation
                        if (
                          e.target.value &&
                          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value)
                        ) {
                          setErrors({
                            ...errors,
                            emailAddress: "Please enter a valid email address",
                          });
                        } else {
                          const newErrors = { ...errors };
                          delete newErrors.emailAddress;
                          setErrors(newErrors);
                        }
                      }}
                    />
                  </Grid>
                  {!formData.isPaintingVendorSelected && (
                    <>
                      <Grid item xs={12} sm={6} md={4}>
                        <CustomInput
                          placeholder="Insert Google Map Link"
                          title="Business Location"
                          name="businessLocation"
                          size="small"
                          value={formData?.businessLocation}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <CustomInput
                          placeholder="Enter Website URL"
                          title="Website"
                          name="website"
                          size="small"
                          value={formData?.website}
                          onChange={handleInputChange}
                          errorMessage={
                            errors.website ? (
                              <span style={{ color: "var(--error-color)" }}>
                                Please Enter Valid URL
                              </span>
                            ) : null
                          }
                          error={errors.website}
                          onBlur={(e) => {
                            if (saveButtonClicked) {
                              validateForm();
                            }
                            setRequiredFields({
                              ...requiredFields,
                              website: validate(e.target.value, "url"),
                            });
                          }}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sm={6} md={4}>
                    <GlobalDropdownField
                      name="reliability"
                      label="Reliability"
                      value={formData?.reliability}
                      onChange={handleInputChange}
                      placeholder="Choose Reliability"
                      variant="citySelect"
                      renderValueFn={(selected) =>
                        selected?.length === 0 ? (
                          <p
                            style={{
                              color: "var(--light-gray)",
                              fontSize: "1rem",
                            }}
                          >
                            Choose Reliability
                          </p>
                        ) : (
                          selected
                        )
                      }
                      options={[
                        { value: "5", label: "5 Star" },
                        { value: "4", label: "4 Star" },
                        { value: "3", label: "3 Star" },
                        { value: "2", label: "2 Star" },
                        { value: "1", label: "1 Star" },
                      ]}
                      error={!!errors.reliability}
                      errorMessage={errors.reliability}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Years of Experience"
                      title="Total Years in Business"
                      name="yearsInBusiness"
                      type="number"
                      size="small"
                      value={formData?.yearsInBusiness}
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress} // Add this
                      InputProps={{ inputProps: { min: 0 } }}
                      onFocus={handleFocus}
                      allowDecimal={false}
                    />
                  </Grid>
                  {/* Number of Employees */}
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Number Of Employees"
                      name="numberOfEmployees"
                      title="Number of Employees"
                      type="number"
                      size="small"
                      value={formData?.numberOfEmployees}
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e);
                        }
                      }}
                      onKeyPress={(e) => handleKeyPress(e)}
                      InputProps={{ inputProps: { min: 0 } }}
                      onFocus={handleFocus}
                      allowDecimal={false}
                      onBlur={handleBlur}
                    />
                  </Grid>
                  {!formData.isPaintingVendorSelected && (
                    <>
                      {/* Number of Skilled Manpower */}
                      <Grid item xs={12} sm={6} md={4}>
                        <CustomInput
                          placeholder="Enter Number Of Skilled Manpower"
                          title="Number of Skilled Manpower"
                          type="number"
                          name="numberOfSkilledManpower"
                          size="small"
                          value={formData?.numberOfSkilledManpower}
                          onChange={(e) => {
                            if (!e.target.value.startsWith(" ")) {
                              handleInputChange(e);
                            }
                          }}
                          onKeyPress={(e) => handleKeyPress(e)}
                          InputProps={{ inputProps: { min: 0 } }}
                          onFocus={handleFocus}
                          allowDecimal={false}
                          onBlur={handleBlur}
                        />
                      </Grid>

                      {/* Number of Unskilled Manpower */}
                      <Grid item xs={12} sm={6} md={4}>
                        <CustomInput
                          placeholder="Enter Number Of Unskilled Manpower"
                          title="Number of Unskilled Manpower"
                          type="number"
                          name="numberOfUnskilledManpower"
                          size="small"
                          value={formData?.numberOfUnskilledManpower}
                          onChange={(e) => {
                            if (!e.target.value.startsWith(" ")) {
                              handleInputChange(e);
                            }
                          }}
                          onKeyPress={(e) => handleKeyPress(e)}
                          InputProps={{ inputProps: { min: 0 } }}
                          onFocus={handleFocus}
                          allowDecimal={false}
                          onBlur={handleBlur}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sm={6} md={4}>
                    <GlobalDropdownField
                      name="registeredInESIPF"
                      label="Registered in ESI/PF"
                      value={formData?.registeredInESIPF}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        })
                      }
                      placeholder="Select"
                      options={[
                        { value: true, label: "Yes" },
                        { value: false, label: "No" },
                      ]}
                      renderValueFn={(selected) => {
                        if (formData?.registeredInESIPF == true) return "Yes";
                        if (formData?.registeredInESIPF == false) return "No";
                        return "Select";
                      }}
                      error={!!errors.registeredInESIPF}
                      errorMessage={errors.registeredInESIPF}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter PAN Number"
                      name="PANNumber"
                      title="PAN Number"
                      size="small"
                      value={formData?.PANNumber}
                      allowDecimal={false}
                      error={errors.PANNumber}
                      errorMessage={
                        errors.PANNumber ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please enter a valid pan number
                          </span>
                        ) : null
                      }
                      onChange={(e) => {
                        if (
                          e.target.value.length < 11 &&
                          !e.target.value.startsWith(" ")
                        ) {
                          handleInputChange(e);
                        }
                      }}
                      onKeyPress={handleKeyPress} // Add this
                      onBlur={(e) => {
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Bank Account Number"
                      name="bankAccountNumber"
                      title="Bank Account Number"
                      type="number"
                      size="small"
                      value={formData?.bankAccountNumber}
                      allowDecimal={false}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 20) {
                          handleInputChange(e);
                        }
                      }}
                      onKeyPress={(e) => handleKeyPress(e)}
                      maxLength={20}
                      onFocus={handleFocus}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Bank Name"
                      name="bankName"
                      title="Bank Name"
                      size="small"
                      value={formData?.bankName}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (
                          !e.target.value.startsWith(" ") &&
                          /^[A-Za-z\s]*$/.test(value)
                        ) {
                          handleInputChange(e);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Bank IFSC Code"
                      name="bankIFSCCode"
                      title="IFSC Code"
                      size="small"
                      value={formData?.bankIFSCCode}
                      allowDecimal={false}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!value.startsWith(" ") && value.length <= 11) {
                          handleInputChange(e);
                        }
                      }}
                    />
                  </Grid>
                  {!formData.isPaintingVendorSelected && (
                    <>
                      <Grid item xs={12} sm={6} md={4}>
                        <CustomInput
                          placeholder="Enter Avg Turnover of last 3 Years in lakhs"
                          title="Avg. Turnover in Lakhs(last 3 years)"
                          name="avgTurnoverLast3Years"
                          type="number"
                          size="small"
                          value={formData?.avgTurnoverLast3Years}
                          onChange={handleInputChange}
                          onKeyPress={handleKeyPress} // Add this line
                          InputProps={{ inputProps: { min: 0 } }}
                          onFocus={handleFocus}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <CustomInput
                          placeholder="Enter Production Area"
                          title="Production Area (in sq. ft)"
                          name="productionArea"
                          type="number"
                          size="small"
                          value={formData?.productionArea}
                          onChange={handleInputChange}
                          onKeyPress={handleKeyPress} // Add this
                          InputProps={{ inputProps: { min: 0 } }}
                          onFocus={handleFocus}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <GlobalDropdownField
                          name="scalingFactors"
                          label="Factors that will help you scale?"
                          value={formData?.scalingFactors || []}
                          onChange={(e) =>
                            handleInputChange({
                              target: {
                                name: e.target.name,
                                value: e.target.value,
                              },
                            })
                          }
                          placeholder="Choose Scaling Factors"
                          options={[
                            "Skilled manpower",
                            "Capital",
                            "Marketing",
                            "Mfg. Capability",
                            "Machinery",
                            "Personal Factors",
                          ].map((label) => ({
                            value: label,
                            label,
                          }))}
                          multiple={true}
                          variant="multiSelect"
                          error={errors.scalingFactors}
                          errorMessage={errors.scalingFactors}
                          renderValueFn={(selected) => {
                            if (!selected || selected.length === 0) {
                              return (
                                <p className="text-[1rem] text-[#a2a2a2]">
                                  Choose Scaling Factors
                                </p>
                              );
                            }
                            return selected.join(", ");
                          }}
                        />
                      </Grid>

                      {/* certificate */}
                      <Grid item xs={12} sm={6} md={4}>
                        <GlobalDropdownField
                          name="certifications"
                          label="Certifications"
                          value={formData.certifications.map((c) => c.label)}
                          onChange={handleCertificationChange}
                          multiple
                          variant="multiSelect"
                          placeholder="Choose certifications"
                          options={[
                            { label: "3M", value: "3M" },
                            { label: "LG", value: "LG" },
                            { label: "Avery", value: "Avery" },
                          ]}
                          error={!!errors.certifications}
                          errorMessage={errors.certifications}
                          onBlur={() => {
                            if (formData.certifications.length > 0) {
                              const missingCertificates =
                                formData.certifications.filter(
                                  (cert) =>
                                    !cert.photo || cert.photo.length === 0,
                                );
                              if (missingCertificates.length > 0) {
                                setErrors((prev) => ({
                                  ...prev,
                                  certifications:
                                    "Please upload certificates for all selected certifications",
                                }));
                              }
                            }
                          }}
                          renderValueFn={(selected) =>
                            selected.length === 0 ? (
                              <p className="text-[1rem] text-[#a2a2a2]">
                                Choose certifications
                              </p>
                            ) : (
                              selected.join(", ")
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <CustomInput
                          placeholder="Credit Limit"
                          name="creditLimit"
                          title="Credit Limit"
                          type="number"
                          size="small"
                          value={formData?.creditLimit}
                          onChange={handleInputChange}
                          onKeyPress={handleKeyPress} // Add this
                          InputProps={{ inputProps: { min: 0 } }}
                          onFocus={handleFocus}
                        />
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} sm={6} md={4}>
                    <GlobalDropdownField
                      name="badge"
                      label="Badge"
                      value={formData?.badge}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        })
                      }
                      placeholder="Select Badge"
                      options={[
                        { value: "Platinum", label: "Platinum" },
                        { value: "Gold", label: "Gold" },
                        { value: "Silver", label: "Silver" },
                        { value: "None", label: "None" },
                      ]}
                      renderValueFn={(selected) => selected || "Select Status"}
                      error={!!errors.badge}
                      errorMessage={errors.badge}
                    />
                  </Grid>
                  {formData.isPaintingVendorSelected && (
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput
                        name="aadhaarCardNumber"
                        placeholder="Enter Aadhaar Card Number"
                        title="Aadhaar Card Number"
                        size="small"
                        onChange={(e) => {
                          if (
                            !e.target.value.startsWith(" ") &&
                            e.target.value.length < 13
                          ) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={(e) => {
                          emptyInputCheck(e.target.name, e.target.value);
                          if (saveButtonClicked) validateForm();
                        }}
                        value={formData?.aadhaarCardNumber}
                        required
                        type="number"
                        errorMessage={
                          errors.aadhaarCardNumber ? (
                            <span style={{ color: "var(--error-color)" }}>
                              Please Enter aadhaar Number
                            </span>
                          ) : null
                        }
                        error={errors.aadhaarCardNumber}
                        onFocus={handleFocus}
                        onWheel={(e) => e.preventDefault()}
                      />
                    </Grid>
                  )}
                </Grid>
              </div>
            )}
            {!formData.isPaintingVendorSelected && (
              <>
                {/* fabrication machine */}
                <div className={Styles.formstyling}>
                  <div className="flex justify-between items-center mb-2">
                    <h4 className="mx-2 font-bold text-lg">
                      Fabrication Details
                    </h4>
                    <div
                      onClick={handleFabModalOpen}
                      className="cursor-pointer"
                    >
                      <AddIcon
                        color="primary"
                        className="mx-2 font-bold text-lg cursor-pointer"
                      />
                      <span style={{ color: "rgb(25, 118, 210)" }}>
                        Add Fabrication Details
                      </span>
                    </div>
                  </div>
                  {/* {localStorage.getItem("role") != 3 && ( */}
                  <div
                    className={`w-full bg-gray-100 py-6 px-4 ${Styles.vendorSection} `}
                  >
                    {fabArray && fabArray.length > 0 ? (
                      <div
                        className={`grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-h-[600px] overflow-x-hidden overflow-scroll ${Styles["custom1-scrollbar"]}`}
                      >
                        {fabArray.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className={`relative rounded-xl bg-white p-6 shadow-lg `}
                            >
                              {/* Card Content */}
                              <h2 className="text-xl font-bold mt-6 mb-2">
                                {item.category}
                              </h2>
                              <div className="flex justify-between items-center gap-1">
                                <div>
                                  {" "}
                                  {item.subCategory && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Sub Category:</strong>{" "}
                                      {item.subCategory}
                                    </p>
                                  )}{" "}
                                  {item.machineThickness && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Thickness:</strong>{" "}
                                      {item.machineThickness}
                                    </p>
                                  )}{" "}
                                  {item.machineMaterial && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Material:</strong>{" "}
                                      {item.machineMaterial}
                                    </p>
                                  )}{" "}
                                  {item.machineType && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Type:</strong>{" "}
                                      {item.machineType}
                                    </p>
                                  )}{" "}
                                  {item.lengthFoot && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Length:</strong>{" "}
                                      {item.lengthFoot}
                                      {"feet "}{" "}
                                    </p>
                                  )}{" "}
                                  {item.breadthFoot && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Breadth:</strong>{" "}
                                      {item.breadthFoot}
                                      {"feet "}{" "}
                                      {item?.breadthInches &&
                                        item.breadthInches + " inches"}
                                    </p>
                                  )}{" "}
                                  {item.modelMachine && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Model:</strong>{" "}
                                      {item.modelMachine}
                                    </p>
                                  )}
                                  {item.horsepower && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Horse Power:</strong>{" "}
                                      {item.horsepower}
                                    </p>
                                  )}
                                  {item.machineSize && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Size:</strong>{" "}
                                      {item.machineSize} {"inches "}
                                    </p>
                                  )}
                                  {item.numMachines && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>No of Machine:</strong>{" "}
                                      {item.numMachines}
                                    </p>
                                  )}
                                  {item.machineLength && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Length:</strong>{" "}
                                      {item.machineLength}
                                    </p>
                                  )}
                                  {item.machineBreadth && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Breadth:</strong>{" "}
                                      {item.machineBreadth}
                                    </p>
                                  )}
                                  {item.wattage && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Wattage:</strong>{" "}
                                      {item.wattage}
                                    </p>
                                  )}
                                  {item.ageOfMachine && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Age Of Machine:</strong>{" "}
                                      {item.ageOfMachine}
                                      {" yrs"}
                                    </p>
                                  )}
                                  {item.ampereOfMachine && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Ampere:</strong>{" "}
                                      {item.ampereOfMachine}
                                    </p>
                                  )}
                                  {item.powerOfMachine && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Power of Machine:</strong>{" "}
                                      {item.powerOfMachine}
                                    </p>
                                  )}
                                  {item.controllerSetting && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Controller Settings:</strong>{" "}
                                      {item.controllerSetting}
                                    </p>
                                  )}
                                  {item.machineModelNo && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Model:</strong>{" "}
                                      {item.machineModelNo}
                                    </p>
                                  )}
                                </div>
                                <div className="">
                                  {item.fabricationMachineImage && (
                                    <div>
                                      <div className="flex justify-between gap-1 items-center">
                                        <div className="flex justify-center items-center">
                                          <img
                                            className={`object-cover rounded-lg w-28 h-24 ${Styles.vendorSectionImg} cursor-pointer`}
                                            src={item.fabricationMachineImage}
                                            alt="Machine"
                                            onClick={() =>
                                              handleImageClick(
                                                item.fabricationMachineImage,
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {
                                  <Modal
                                    open={isImage}
                                    onClose={() => {
                                      setIsImage(false);
                                      setSelectedImage(null);
                                    }}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <div
                                      className="h-full flex justify-center items-center mx-auto relative"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <img
                                        src={selectedImage}
                                        alt="Machine"
                                        className="object-contain max-w-[80vw] max-h-[90vh]"
                                      />
                                    </div>
                                  </Modal>
                                }
                              </div>

                              <div className="absolute top-3 right-3 flex space-x-2 ">
                                <IconButton
                                  size="small"
                                  color="primary"
                                  aria-label="edit"
                                  onClick={(e) =>
                                    handleFabricationEdit(e, index, item)
                                  }
                                >
                                  <Edit />
                                </IconButton>
                                {localStorage.getItem("role") == -1 && (
                                  <IconButton
                                    size="small"
                                    color="error"
                                    aria-label="delete"
                                    onClick={(e) =>
                                      handleFabricationDelete(e, index, item)
                                    }
                                  >
                                    <Delete />
                                  </IconButton>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <p
                        className={`text-gray-500 text-center mt-4 ${Styles.vendorSectionError}`}
                      >
                        No Fabrication data available
                      </p>
                    )}
                  </div>
                  {/* )} */}
                </div>

                {/* printing */}
                <div className={Styles.formstyling}>
                  <div className="flex justify-between items-center p-2">
                    <h4 className="mx-2 font-bold text-lg">Printing Details</h4>
                    <div onClick={handleModalOpen} className="cursor-pointer">
                      <AddIcon
                        color="primary"
                        className="mx-2 font-bold text-lg cursor-pointer"
                      />
                      <span style={{ color: "rgb(25, 118, 210)" }}>
                        Add Printing Details
                      </span>
                      {/* <Button variant="text">
                  Add Machinery Details
                </Button> */}
                    </div>
                  </div>
                  <div
                    className={`w-full bg-gray-100 py-6 px-4 ${Styles.vendorSection} max-h-[700px] overflow-x-hidden ${Styles["custom1-scrollbar"]}`}
                  >
                    {printMachineArray && printMachineArray.length > 0 ? (
                      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 ">
                        {printMachineArray.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="relative rounded-xl bg-white p-6 shadow-lg"
                            >
                              <h2 className="text-xl font-bold mt-6 mb-2">
                                {item.machinePrintingType}
                              </h2>
                              <h2 className="text-xl font-bold mt-6 mb-2">
                                {item.machinePrintingSubType}
                              </h2>

                              <div className="flex justify-between items-center gap-3 ">
                                <div>
                                  <p className="text-gray-600 mb-1">
                                    <strong>Max. Print Size:</strong>{" "}
                                    {item.maxPrintSize}
                                  </p>

                                  {item.machineBrand && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Brand:</strong>{" "}
                                      {item.machineBrand}
                                    </p>
                                  )}
                                  {item.picoliter && (
                                    <p className="text-gray-600 mb-1">
                                      <strong>Machine Pico Liter:</strong>{" "}
                                      {item.picoliter}
                                    </p>
                                  )}

                                  <p className="text-gray-600 mb-1">
                                    <strong>Age of Machine:</strong>{" "}
                                    {item.ageOfMachine} {" yrs"}
                                  </p>
                                </div>
                                <div>
                                  {item.PrintingMachineImage && (
                                    <div className="flex justify-center items-center cursor-pointer">
                                      <img
                                        src={item.PrintingMachineImage}
                                        alt="Machine"
                                        className={`object-cover rounded-lg w-28 h-24 ${Styles.vendorSectionImg} cursor-pointer`}
                                        onClick={() =>
                                          handleImageClick(
                                            item.PrintingMachineImage,
                                          )
                                        } // Call the function on click
                                      />
                                    </div>
                                  )}
                                  {}
                                </div>
                              </div>
                              {/* Edit and Delete Buttons */}
                              <div className="absolute top-3 right-3 flex space-x-2">
                                <IconButton
                                  size="small"
                                  color="primary"
                                  aria-label="edit"
                                  onClick={(e) =>
                                    handleMachineEdit(e, index, item)
                                  }
                                >
                                  <Edit />
                                </IconButton>
                                {localStorage.getItem("role") == -1 && (
                                  <IconButton
                                    size="small"
                                    color="error"
                                    aria-label="delete"
                                    onClick={(e) =>
                                      handleMachineDelete(e, index, item)
                                    }
                                  >
                                    <Delete />
                                  </IconButton>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <p
                        className={`text-gray-500 text-center mt-4 ${Styles.vendorSectionError}`}
                      >
                        No Printing data available
                      </p>
                    )}
                  </div>
                </div>
              </>
            )}

            {/* product and services */}
            <div className={Styles.formstyling}>
              <div className="flex justify-between items-center p-2">
                <h4 className="mx-2 font-bold text-lg">
                  Product and Services Details
                </h4>
                <div
                  onClick={
                    productArray.length === 0 ? handleProductModalOpen : null
                  }
                  className="cursor-pointer"
                  style={{
                    pointerEvents: productArray.length > 0 ? "none" : "auto",
                    opacity: productArray.length > 0 ? 0.5 : 1,
                  }}
                >
                  <AddIcon
                    color="primary"
                    className="mx-2 font-bold text-lg cursor-pointer"
                  />
                  <span
                    style={{
                      color:
                        productArray.length > 0 ? "gray" : "rgb(25, 118, 210)",
                    }}
                  >
                    Add Product Details
                  </span>
                </div>
              </div>
              <div
                className={`w-full bg-gray-100 py-6 px-4 ${Styles.vendorSection}`}
              >
                {productArray && productArray.length > 0 ? (
                  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {productArray.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="relative rounded-xl bg-white p-6 shadow-lg"
                        >
                          {/* Example of conditional rendering for fields */}
                          {item.fabrication && (
                            <div className="mb-4">
                              <p className="font-semibold">
                                Fabrication Products: Yes
                              </p>
                              <p>{item.typesOfFabrication.join(", ")}</p>
                            </div>
                          )}

                          {item.printingProducts && (
                            <div className="mb-4">
                              <p className="font-semibold">
                                Printing Products : Yes
                              </p>
                              <p>{item.typesOfPrintingProducts.join(", ")}</p>
                            </div>
                          )}

                          {item.paintingProducts && (
                            <div className="mb-4">
                              <p className="font-semibold">
                                Painting Products : Yes
                              </p>
                              <p>{item.typesOfPaintingProducts.join(", ")}</p>
                            </div>
                          )}

                          <div className="absolute top-3 right-3 flex space-x-2">
                            <IconButton
                              size="small"
                              color="primary"
                              aria-label="edit"
                              onClick={(e) => handleProductEdit(e, index, item)}
                            >
                              <Edit />
                            </IconButton>
                            <IconButton
                              size="small"
                              color="error"
                              aria-label="delete"
                              onClick={(e) =>
                                handleProductDelete(e, index, item)
                              }
                            >
                              <Delete />
                            </IconButton>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p
                    className={`text-gray-500 text-center mt-4 ${Styles.vendorSectionError}`}
                  >
                    No Product and Services data available
                  </p>
                )}
              </div>
            </div>
            {/* Product Pricing */}
            {
              <div className={Styles.formstyling}>
                <div className="flex justify-between items-center p-2">
                  <h4 className="mx-2 font-bold text-lg">
                    Product Pricing Details
                  </h4>
                  <div onClick={handleAddRow} className="cursor-pointer">
                    <AddIcon
                      color="primary"
                      className="mx-2 font-bold text-lg cursor-pointer"
                    />
                    <span
                      style={{
                        color: "rgb(25, 118, 210)",
                      }}
                    >
                      Add Product Price Details
                    </span>
                  </div>
                </div>
                <div
                  className={`w-full bg-gray-100 py-6 px-4 ${Styles.vendorSection}`}
                >
                  <ProductPricingSection
                    value={pricingRows}
                    onChange={setPricingRows}
                    categoryOptions={categories}
                    productTypeOptions={productTypeOptions}
                    unitOptions={unitOptions}
                    onCategoryChange={handleCategoryChange}
                  />
                </div>
              </div>
            }
          </form>
          <div className=" grid lg:grid-cols-3 gap-4">
            <div
              className={`${Styles.formstyling} max-h-[400px] overflow-x-hidden`}
            >
              <h4 className="mx-2 font-bold text-lg">Profile photo</h4>

              <div className="">
                <MinMaxFileUploader
                  initialFiles={formData.profilePhoto} // Prepopulate with profile photo
                  onFilesUpload={(urls) =>
                    setFormData({
                      ...formData,
                      profilePhoto: urls, // Store the image as a Data URL for preview
                    })
                  }
                  typeOfFilesAllowed={"image/*"} // Specify allowed file types (only images)
                  maxFiles={1} // Limit to only 1 file
                />
              </div>
            </div>
            <div
              className={`${Styles.formstyling} max-h-[400px] overflow-x-hidden`}
            >
              <h4 className="mx-2 font-bold text-lg">
                Upload Premises And Other Images
              </h4>

              <div className="">
                <FileUploader
                  initialFiles={formData.imagesUploaded}
                  onFilesUpload={handleFilesUpload}
                  typeOfFilesAllowed={"image/*,video/*"}
                />
              </div>
            </div>
            <div
              className={`${Styles.formstyling} max-h-[400px] overflow-x-hidden`}
            >
              <h4 className="mx-2 font-bold text-lg">Vendor Portfolio</h4>

              <div className="">
                <FileUploader
                  initialFiles={formData.vendorimagesUploaded}
                  onFilesUpload={handleVendorFilesUpload}
                  typeOfFilesAllowed={"image/*"}
                />
              </div>
            </div>
            <div
              className={`${Styles.formstyling} max-h-[400px] overflow-x-hidden`}
            >
              <h4 className="mx-2 font-bold text-lg">Cancelled Cheque Photo</h4>
              <div className="">
                <MinMaxFileUploader
                  initialFiles={formData.chequeBookImageURL} // Prepopulate with profile photo
                  onFilesUpload={(urls) =>
                    setFormData({
                      ...formData,
                      chequeBookImageURL: urls, // Store the image as a Data URL for preview
                    })
                  }
                  typeOfFilesAllowed={"image/*"} // Specify allowed file types (only images)
                  maxFiles={1} // Limit to only 1 file
                />
              </div>
            </div>
          </div>
          <div className="grid lg:grid-cols-1 gap-4">
            {formData?.certifications?.length > 0 && (
              <div
                className={`${Styles.formstyling} max-h-[400px] lg:flex overflow-x-hidden`}
              >
                {formData.certifications.map((cert) => (
                  <div key={cert.label} className="mt-2 mr-4">
                    <div className="flex items-center mb-2">
                      <p className="text-sm font-medium">
                        {cert.label} Certificate Upload *
                      </p>
                      {(!cert.photo || cert.photo.length === 0) && (
                        <span className="ml-2 text-red-500 text-xs">
                          (Required)
                        </span>
                      )}
                      {cert.photo && cert.photo.length > 0 && (
                        <span className="ml-2 text-green-500 text-xs">
                          ✓ Uploaded
                        </span>
                      )}
                    </div>
                    <FileUploader
                      initialFiles={cert?.photo?.[0] ? [cert.photo[0]] : []}
                      onFilesUpload={(urls) =>
                        handleFilesUploadCertificate(cert.label, urls)
                      }
                      typeOfFilesAllowed="image/*"
                      required={true}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </DialogContent>

        <DialogActions>
          <div className="w-30">
            <GlobalButton
              variant="secondary"
              size="medium"
              onClick={handleClose}
            >
              {`Close`}
            </GlobalButton>
          </div>
          <div className="w-30">
            <GlobalButton
              variant="primary"
              size="medium"
              isLoading={isLoading}
              disabled={!formData.isPaintingVendorSelected && !isGstVerified}
              style={{
                cursor:
                  !formData.isPaintingVendorSelected && !isGstVerified
                    ? "not-allowed"
                    : "pointer",
              }}
              onClick={(e) => {
                setSaveButtonClicked(true);
                handleSubmit(e);
              }}
            >
              {selectedVendorData._id ? "Update" : "Save"}
            </GlobalButton>
          </div>
        </DialogActions>
      </Dialog>

      {/* PrintMachine */}
      <PrintMachineModal
        substrate={substrate}
        isOpen={isMachineModalOpen}
        width={width}
        isOtherSelected={isOtherSelected}
        brandNames={brandNames}
        handleSubmit={handleMachineSubmit}
        handleChange={handleMachineChange}
        handleClose={handleMachineModalClose}
        formData={PmformData}
        setPmFormData={setPmFormData}
        printingOptions={printingOptions}
        printingSubOptions={printingSubOptions}
        isEditing={isprintMachineEditing}
        error={pmerror}
      />
      {/* Fabrication */}
      <FabricationModal
        setFabFormData={setFabFormData}
        setDeleteImages={setDeleteImages}
        isOpen={isfabModalOpen}
        isOtherSelected={isOtherSelected}
        handleSubmit={handleFabSubmit}
        handleChange={handleFabChange}
        getMapping={getMapping}
        handleClose={handleFabModalClose}
        handleMainCategoryChange={handleMainCategoryChange}
        formData={FabformData}
        setFormData={setFabFormData}
        isEditing={isfabEditing}
      />
      {/* ProductsServicesModal */}
      <ProductsServicesModal
        isOpen={isProductModalOpen}
        formData={ProductformData}
        handleChange={handleProductChange}
        handleClose={handleProductModalClose}
        handleSubmit={handleProductSubmit}
        isEditing={isProductEditing}
      />
    </div>
  );
};

export default VendorOnboardingForm;
